import { render, staticRenderFns } from "./OtherIncomePaymentForm.vue?vue&type=template&id=50c0d9c0"
import script from "./OtherIncomePaymentForm.vue?vue&type=script&lang=js"
export * from "./OtherIncomePaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports